<template>
  <div class="d-flex">
    <div class="d-flex-left">
      <div v-for="(item,index) in customer_menu" :key="index">
        <el-link :class="{'activeIndex':indexName==item.index}" type="primary" @click="setMenu(item)">{{ item.name }}</el-link>
      </div>
       <!-- <el-link type="primary" @click="setMenu('Execute')">装修管理执行情况明细表</el-link>
        <el-link type="primary" @click="setMenu('SummarizeExecute')">装修管理执行情况汇总表</el-link>
        <el-link type="primary" @click="setMenu('State')">装修状态管理汇总表</el-link> -->
    </div>
    <div class="d-flex-right">
      <div style="margin-left: 5px">
        <div style="margin-top: 5px">
          <el-button size="mini" @click="goBack">返回</el-button>
          <el-button size="mini" @click="excel" v-if="indexName">导出：{{textName}}</el-button>
        </div>
        <el-descriptions :column="2" size="mini" border style="margin-top: 8px"  v-if="indexName">
          <el-descriptions-item label="项目">
            <el-select
              v-model="pid"
              size="mini"
              multiple
              collapse-tags
              filterable
              style="width: 70%"
              placeholder="选择项目"
            >
              <el-option
                v-for="item in projecta"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <span style="cursor: pointer" @click="completeProject">全选</span>
            <span style="margin-left: 3px; cursor: pointer" @click="cancelProject"
              >取消</span
            >
          </el-descriptions-item>
          <el-descriptions-item label="战区">
            <el-select
              v-model="zoneIds"
              size="mini"
              multiple
              collapse-tags
              filterable
              style="width: 70%"
              placeholder="选择战区"
            >
              <el-option
                v-for="item in zones"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <span style="cursor: pointer" @click="completeZone">全选</span>
            <span style="margin-left: 3px; cursor: pointer" @click="cancelZone"
              >取消</span
            >
          </el-descriptions-item>
          <el-descriptions-item label="装修提交日期" v-if="indexName=='State'">
            <el-date-picker
              v-model="startDate"
              size="mini"
              type="date"
              format="yyyy-MM-dd"
              value-format="timestamp"
              placeholder="选择开始日期"
            />
            至
            <el-date-picker
              v-model="endDate"
              size="mini"
              type="date"
              format="yyyy-MM-dd"
              value-format="timestamp"
              placeholder="选择结束日期"
            />
          </el-descriptions-item>

          <el-descriptions-item label="月份" v-if="indexName!='State'">
            <el-date-picker
              v-model="monthDate"
              size="mini"
              type="month"
              format="yyyy-MM"
              value-format="timestamp"
              placeholder="月份"
            />
          </el-descriptions-item>

        </el-descriptions>

      </div>

    </div>
  </div>

</template>

<script>
import ErpTree from "@/components/Admin/Common/erp-tree";
import AppConfig from "../../../../config/AppConfig";
export default {
  name: "DecorationInspectionRecordForm",
  components: {
    ErpTree,
  },
  data() {
    return {
      pid: [],
      zoneIds: [],
      startDate: "",
      endDate: "",
      monthDate: "",
      projecta: [],
      zones: [],
      customer_menu:[
        {name:"装修管理执行情况明细表",index:"Execute"},
        {name:"装修管理执行情况汇总表",index:"SummarizeExecute"},
        {name:"装修状态管理汇总表",index:"State"}
      ],
      indexName: "",
      textName: ""
    };
  },
  mounted() {
    this.projects();
    this.zone();
  },
  methods: {
    excel() {
      let _this = this;

      if(_this.indexName == 'State' && !_this.startDate) {
        _this.$message.error('请选择装修日期开始时间！');
        return
      }
      if(_this.indexName != 'State' && !_this.monthDate) {
        _this.$message.error('请选择月份！');
        return
      }

      let loginB = localStorage.getItem('login')
      let tokenB = localStorage.getItem('token')
      let param = "?login="+loginB+"&token="+tokenB+"&pid="+this.pid+"&zoneIds="+this.zoneIds+"&indexName="+this.indexName+"&startDate="+this.startDate / 1000+"&endDate="+this.endDate / 1000+"&monthDate="+this.monthDate / 1000
      const url = AppConfig.erp_server + '/admin/HouseFurnish/exportExcel'+param
      window.open(url)
    },
    //名下项目
    projects() {
      this.$myhttp
        .get("admin/common/pindex", {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          // 异步执行成功后
          this.projecta = backdata.data.data;
        });
    },
    completeProject() {
      let data = this.projecta;
      let ids = [];
      data.map((req) => {
        ids.push(req.id);
      });
      this.pid = ids;
    },
    //取消
    cancelProject() {
      this.pid = [];
    },
    //名下战区
    zone() {
      this.$myhttp
        .post(
          "admin/ZoneManage/index",
          { type: 1, pageSize: 50 },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          // 异步执行成功后
          this.zones = backdata.data.data;
        });
    },
    completeZone() {
      let data = this.zones;
      let ids = [];
      data.map((req) => {
        ids.push(req.id);
      });
      this.zoneIds = ids;
    },
    //取消
    cancelZone() {
      this.zoneIds = [];
    },
    goBack() {
        this.$router.go(-1); // 使用Vue Router的go方法返回上一页
    },
    setMenu(item) {
      this.indexName = item.index
      this.textName = item.name
    }
  },
};
</script>


<style lang="scss" scoped>
  .d-flex {
    display: flex;
    margin: 1%;
    width: 98%;
  }

  .d-flex-left {
    margin-right: 10px;
    border-right: 1px solid #eee;
    padding-right: 10px;
  }

  .d-flex-right {
    flex: 1;
    //margin: 30px;
    width: 100%;
    overflow-y: scroll;
    height: calc( 100vh - 150px );

    .header{
      padding-top: 5px;
      padding-bottom: 10px;
      position: sticky;
      top: 0;
      left: 0;
      right: 0;
      z-index: 10;
      background-color: #FFFFFF;
    }

    .btn-item {
      margin-top: 10px;
      margin-right: 30px;
    }

   .el-tabs__item{
      color: black;
    }
  }

  .activeIndex {
    color: #42b983
  }

</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/DecorationInspectionRecordForm.vue